<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-10 mt-12">
    <div class="mb-10 sm:mb-0 flex justify-center" v-for="projectImage, index in projectImages" :key="index">
      <img
        :src="projectImage.img"
        class="rounded-xl cursor-pointer shadow-lg sm:shadow-none"
        :alt="projectImage.img"
        @click="openModal(projectImage.img)"
      />
      <!-- Modal -->
      <div
        v-if="showModal && selectedImage === projectImage.img"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
        @click.self="closeModal"
      >
        <img :src="selectedImage" class="modal-image max-w-full max-h-[80vh] rounded-xl shadow-2xl" />
        <button
          class="absolute top-4 right-4 text-white text-3xl font-bold"
          @click="closeModal"
          aria-label="Close"
        >&times;</button>
      </div>
      <!-- <img :src="projectImage.img" class="rounded-xl cursor-pointer shadow-lg sm:shadow-none"
        alt="{{ projectImage.img }}" /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['projectImages'],
  data() {
    return {
      showModal: false,
      selectedImage: '',
    };
  },
  methods: {
    openModal(image) {
      this.selectedImage = image;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedImage = '';
    },
  },
};
</script>

<style scoped>
/* img {
  width: 100%;
  height: 100%;
  max-height: 300px;
} */
.modal-image {
  width: auto;
  height: auto;
  max-width: 90%;
  max-height: 90%;
}
</style>